var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveStreaming = function SvgLiveStreaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5.637 5.637a1 1 0 1 0-1.414-1.414 11 11 0 0 0 0 15.554 1 1 0 0 0 1.414-1.414 9 9 0 0 1 0-12.726m14.14-1.414a1 1 0 1 0-1.414 1.414 9 9 0 0 1 0 12.726 1 1 0 1 0 1.414 1.414 11 11 0 0 0 0-15.554M8.467 8.458a1 1 0 1 0-1.414-1.415 7 7 0 0 0 0 9.905 1 1 0 0 0 1.414-1.415 5 5 0 0 1 0-7.075m8.48-1.405a1 1 0 1 0-1.414 1.415 5 5 0 0 1 0 7.075 1 1 0 1 0 1.414 1.415 7 7 0 0 0 0-9.905",
    clipRule: "evenodd"
  })));
};
export default SvgLiveStreaming;